import {Inject, Injectable} from "@angular/core";
import {
    L10N_CONFIG,
    L10nCache,
    L10nConfig,
    L10nProvider,
    L10nTranslationFallback,
    L10nTranslationLoader
} from 'angular-l10n';
import {Observable} from 'rxjs';
import {LANG_HYPHEN_REG_BY_LOCALE, Locale} from '../../enums/language';

@Injectable()
export class TranslationFallback implements L10nTranslationFallback {

    constructor(
        @Inject(L10N_CONFIG) private config: L10nConfig,
        private cache: L10nCache,
        private translationLoader: L10nTranslationLoader
    ) {}

    /**
     * Translation data will be merged in the following order:
     * 'en-US'
     * 'language-script'
     */
    public get(language: string, provider: L10nProvider): Observable<any>[] {
        let fallbackLanguages = [
            language
        ];

        const enUsLang = LANG_HYPHEN_REG_BY_LOCALE[Locale.en_US];

        if (language !== enUsLang) {
            fallbackLanguages.unshift(enUsLang);
        }

        return fallbackLanguages.map(fallbackLanguage => {
            let loader = this.translationLoader.get(fallbackLanguage, provider);

            if (this.config.cache) {
                loader = this.cache.read(`${provider.name}-${fallbackLanguage}`, loader);
            }

            return loader;
        });
    }

}
